export default "__VITE_ASSET__fabff68c__"